<template>
  <div v-if="access !== null">
    <EditBannerPopUp
      :activate="active"
      @callback="callBackPopUp"
      @withClose="loadData"
      :passData="passData"
    />
    <header class="w-full mb-4">
      <vx-card>
        <div class="mb-base mt-4 vx-row justify-between items-top">
          <section class="vx-col md:w-1/2 lg:w-1/2 xl:w-1/2 sm:w-full flex justify-start">
            <span class="text-black text-2xl">Banner PPOB</span>
          </section>
          <section class="vx-col md:w-1/2 lg:w-1/2 xl:w-1/2 sm:w-full flex justify-end">
            <vs-button @click="openPopUp(null)" v-if="access.create === 1"
              >Tambah Banner PPOB</vs-button
            >
          </section>
        </div>
        <div class="vx-row justify-between items-center">
          <section class="mb-base vx-col md:w-2/5 lg:w-2/5 xl:w-2/5 sm:w-full">
            <div class="w-full gap-2 flex justify-start items-center">
              <!-- <vs-dropdown vs-trigger-click class="cursor-pointer">
              <vs-button icon-after icon="expand_more">Aksi</vs-button>
              <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button>
              <vs-dropdown-menu>
                <vs-dropdown-item>
                  <span>Hapus</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown> -->
              <vs-dropdown vs-trigger-click class="cursor-pointer">
                <div
                  class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
                >
                  <span class="mr-2">{{ `entries ${limit}` }}</span>
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>
                <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                <vs-dropdown-menu>
                  <vs-dropdown-item
                    v-for="(item, index) in limitDataTables"
                    :key="index"
                    @click="limit = item"
                  >
                    <span>{{ item }}</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>
          </section>
          <section class="mb-base vx-col md:w-3/5 lg:w-3/5 xl:w-3/5 sm:w-full">
            <div class="vx-row justify-end items-center">
              <v-select
                class="vx-col lg:w-1/3 md:w-1/3 sm:w-full lg:mr-0"
                v-model="activeBanner"
                :reduce="(v) => v.id"
                :options="[
                  {
                    id: 1,
                    text: 'Aktif',
                  },
                  {
                    id: 0,
                    text: 'Tidak Aktif',
                  },
                ]"
                label="text"
                placeholder="Pilih Status Ke-aktifan"
              />
              <vs-input
                class="vx-col lg:w-1/3 md:w-1/3 sm:w-full"
                v-model="search"
                placeholder="Cari..."
              />
            </div>
          </section>
        </div>
      </vx-card>
    </header>
    <main class="w-full">
      <div class="vx-row flex justify-start flex-row">
        <div
          class="vx-col sm:w-full md:w-1/3 lg:w-1/3 xl:w-1/3 mb-4"
          v-for="(item, index) in banners"
          :key="index"
        >
          <card-banner
            :item="item"
            @edit="access.update === 1 ? openPopUp(item) : {}"
            @onDelete="dialogDelete(item.id, item.name)"
            :accessDelete="access.delete === 1"
          />
        </div>
      </div>
    </main>
    <footer class="mt-2 w-full flex justify-items-end">
      <vs-pagination :total="totalPage" v-model="currentPg"></vs-pagination>
    </footer>
  </div>
</template>

<script>
import CardBanner from "@/views/banners/component/CardBanner.vue";
import limitDataTables from "@/limitDataTable.js";
import EditBannerPopUp from "@/views/banners/component/EditBannerPPOBPopUp.vue";

export default {
  components: {
    CardBanner,
    EditBannerPopUp,
  },
  data() {
    return {
      pagination: {
        start: 0,
        length: limitDataTables[0],
      },
      currentPg: 1,
      search: "",
      limitDataTables,
      access: null,
      activeBanner: null,
      limit: limitDataTables[0],
      banners: [],
      active: false,
      passData: null,
      params: {},
    };
  },
  computed: {
    totalPage() {
      let pages = this.$store.state.banner.totalBannerPPOB / parseInt(this.limit);
      let number = Math.floor(pages);
      if (pages <= parseFloat(number)) {
        return number;
      }

      return number + 1;
    },
    filters() {
      return {
        search: this.search,
        activeBanner: this.activeBanner,
      };
    },
  },
  watch: {
    filters: {
      handler(v) {
        let statusObj = {};
        let searchObj = {};

        if (v.search !== "") {
          searchObj = {
            filter: "name",
            search: this.search,
          };
        } else {
          searchObj = {};
        }

        if (v.statusObj !== null) {
          statusObj = {
            status: this.activeBanner,
          };
        } else {
          statusObj = {};
        }

        this.params = { ...statusObj, ...searchObj };
        this.getData();
      },
      deep: true,
    },
    totalPage() {
      if (this.currentPg > this.totalPage) {
        this.currentPg = this.totalPage;
      }
    },
    limit() {
      this.pagination.length = parseInt(this.limit);
      this.getData();
    },
    currentPg() {
      this.pagination.start =
        this.currentPg <= 1
          ? 0
          : this.currentPg * parseInt(this.limit) - parseInt(this.limit);
      this.getData();
    },
  },
  methods: {
    callBackPopUp(val) {
      this.active = val;
      this.passData = null;
    },
    loadData(val) {
      if (val) {
        this.getData();
      }
    },
    openPopUp(item) {
      this.active = true;
      this.passData = item;
    },
    dialogDelete(id, name) {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: name && id ? `Hapus ${name} ?` : "Hapus Item Terpilih ?",
        text:
          name && id
            ? `Anda yakin ingin menghapus item ${name}`
            : "Anda yakin ingin menghapus item yang terpilih",
        accept: () => {
          if (name && id) {
            this.delete(id);
          } else {
            // eslint-disable-next-line no-lonely-if
            if (this.selected.length === 0) {
              this.$vs.notify({
                title: "Tidak ada item yang dipilih",
                text: "Pilihlah salah satu item atau semua item",
                color: "danger",
                position: "top-right",
              });
            } else {
              // eslint-disable-next-line prefer-const
              for (let i in this.selected) {
                this.delete(this.selected[i].id);
              }
            }
          }
        },
      });
    },
    delete(id) {
      this.$vs.loading({
        container: this.$refs.loadBannersPPOB,
        color: "primary",
      });
      const fungsi = {
        fungsi: 1,
      };
      this.$store
        .dispatch("banner/cudBannerPPOB", [Object.assign(fungsi, { id: id })])
        .then((v) => {
          this.$vs.notify({
            position: "top-right",
            title: "Menghapus Sukses!",
            text: `Banner PPOB ${v.name} Berhasil dihapus`,
            iconPack: "feather",
            icon: "icon-smile",
            color: "primary",
          });
          this.getData();
        })
        .catch((e) => {
          this.$vs.loading.close(this.$refs.loadBannersPPOB);
          if (e.response) {
            console.error(e.response.data.message);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          } else {
            console.error(e);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: "Terjadi kesalahan, silahkan periksa jaringan anda",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
    getData() {
      this.$vs.loading({
        container: this.$refs.loadBannersPPOB,
        color: "primary",
      });
      this.$store
        .dispatch("banner/getBannerPPOB", { ...this.params, ...this.pagination })
        .then((v) => {
          this.$vs.loading.close(this.$refs.loadBannersPPOB);
          this.banners = v.data;
        })
        .catch((e) => {
          this.$vs.loading.close(this.$refs.loadBannersPPOB);
          if (e.response) {
            console.error(e.response.data.message);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          } else {
            console.error(e);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: "Terjadi kesalahan, silahkan periksa jaringan anda",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
  },
  mounted() {
    this.getData();
  },
  created() {
    if (this.$store.state.auth.profileAccess !== null) {
      if (
        this.$store.state.auth.profileAccess.menu.find(
          (e) => e.menu.url === "/dashboard/banner-ppob"
        )
      ) {
        this.access = this.$store.state.auth.profileAccess.menu.find(
          (e) => e.menu.url === "/dashboard/banner-ppob"
        );
      }
    }
  },
};
</script>
